import {
    GlobalNav,
    GlobalNavProps
} from "@/patterns/global-nav/src/nav-global";
export type { GlobalNavProps } from "@/patterns/global-nav/src/nav-global";

const UniformGlobalNav = ({
    // This productKey is used for UFO instrumentation
    // This prop is standardized to the value `uniform`
    // See ldr/0018-set-standard-uniform-globalnav-productkey.md for more details
    productKey = "uniform",
    isShowTryNowLink = true
}: GlobalNavProps) => (
    <GlobalNav productKey={productKey} isShowTryNowLink={isShowTryNowLink} />
);

export default UniformGlobalNav;
